import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcDialog from '@/components/Dialog.vue';
import * as XLSX from 'xlsx';
const { EleResize } = require('@/assets/js/eresize.js');
let StatisticUsage = class StatisticUsage extends Vue {
    constructor() {
        super();
        this.exporting = false;
        this.pageConfig = [];
        this.snackbar = new CBcSnackbar();
        // 设备类型列表（用于动态表头和图表展示）
        this.deviceTypes = [];
        // 设备型号
        this.modeTableOptions = {
            visible: false,
            loading: false,
            desserts: [],
            // 动态表头，初始为默认表头，将通过接口数据更新
            headers: [{
                    text: '设备名称',
                    align: 'center',
                    sortable: false,
                    value: 'name',
                    width: 120
                }, {
                    text: '汇总',
                    align: 'center',
                    sortable: false,
                    value: 'total',
                    minWidth: 80
                }],
            echartsOption: {
                domKey: 'charts_usage_mode',
                title: {
                    show: false,
                    textStyle: {
                        color: '#bcbcbc'
                    },
                    text: '没有数据',
                    left: 'center',
                    top: 'center',
                },
                color: ['#5793f3', '#d14a61', '#675bba'],
                tooltip: {
                    trigger: 'axis'
                },
                toolbox: {
                    feature: {
                        dataView: { show: true, readOnly: false },
                        restore: { show: true },
                        saveAsImage: {}
                    }
                },
                dataZoom: [
                    {
                        show: true,
                        realtime: true,
                    },
                    {
                        type: 'inside',
                        realtime: true,
                    }
                ],
                xAxis: {
                    type: 'category',
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#5793f3'
                        }
                    },
                    axisPointer: {
                        label: {
                            formatter: (params) => `设备型号: ${params.value}`
                        }
                    },
                    data: []
                },
                yAxis: [
                    {
                        name: '使用率(%)',
                        position: 'left',
                        silent: false,
                        splitLine: {
                            show: false
                        },
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }
                ],
                series: [
                    {
                        data: [],
                        name: '使用率',
                        type: 'bar',
                        barMaxWidth: '40',
                        smooth: true,
                        animationDelay: (idx) => idx * 10,
                        itemStyle: {
                            normal: {
                                color: '#3873ff',
                                label: {
                                    show: true,
                                    position: 'top',
                                    textStyle: {
                                        color: '#3873ff'
                                    },
                                    formatter: '{c} %'
                                }
                            }
                        }
                    },
                    {
                        data: [],
                        name: '使用率',
                        stack: '使用率',
                        type: 'line',
                        smooth: true,
                        animationDelay: (idx) => idx * 10,
                    },
                    {
                        type: 'bar',
                        barWidth: 1,
                        data: [],
                        itemStyle: {
                            normal: {
                                shadowBlur: 1,
                                color: (params) => {
                                    const indexColor = params.value;
                                    if (indexColor >= 99) {
                                        return '#45ef96';
                                    }
                                    else if (indexColor >= 90) {
                                        return '#ffed8b';
                                    }
                                    else {
                                        return '#ffb8af';
                                    }
                                }
                            }
                        },
                        animationDelay: (idx) => idx * 10 + 100
                    }
                ],
                animationEasing: 'elasticOut',
                animationDelayUpdate: (idx) => idx * 5,
            }
        };
        // 区域
        this.areaTableOptions = {
            visible: false,
            loading: false,
            desserts: [],
            pageSize: 10,
            page: 1,
            total: 1,
            headersFirst: [{
                    text: '责任区域',
                    align: 'center',
                    colspan: 1,
                    rowspan: 2,
                    borderBottom: true,
                    borderRight: true,
                    value: 'duty_area',
                    valueAlign: 'left'
                }, {
                    text: '设备总数',
                    align: 'center',
                    colspan: 1,
                    rowspan: 2,
                    borderBottom: true,
                    borderRight: true,
                    value: 'device_total'
                }, {
                    text: '使用总数',
                    align: 'center',
                    colspan: 1,
                    rowspan: 2,
                    borderBottom: true,
                    borderRight: true,
                    value: 'usage_total'
                }, {
                    text: '多功能机AL-01',
                    align: 'center',
                    sortable: false,
                    colspan: 2,
                    rowspan: 1,
                    borderBottom: true,
                    borderRight: true,
                    value: ['al_01_install', 'al_01_usage']
                }, {
                    text: '台式西林AL-XL-03',
                    align: 'center',
                    sortable: false,
                    colspan: 2,
                    rowspan: 1,
                    borderBottom: true,
                    borderRight: true,
                    value: ['al_xl_03_install', 'al_xl_03_usage']
                }, {
                    text: '台式西林AL-XL-04',
                    align: 'center',
                    sortable: false,
                    colspan: 2,
                    rowspan: 1,
                    borderBottom: true,
                    borderRight: true,
                    value: ['al_xl_04_install', 'al_xl_04_usage']
                }, {
                    text: '安瓿机AL-AB-02',
                    align: 'center',
                    sortable: false,
                    colspan: 2,
                    rowspan: 1,
                    borderBottom: true,
                    borderRight: true,
                    value: ['al_ab_02_install', 'al_ab_02_usage']
                }, {
                    text: '自动上药安瓿AL-AB-02A',
                    align: 'center',
                    sortable: false,
                    colspan: 2,
                    rowspan: 1,
                    borderBottom: true,
                    borderRight: true,
                    value: ['al_ab_02a_install', 'al_ab_02a_usage']
                }, {
                    text: '分液仪BC-LS-01',
                    align: 'center',
                    sortable: false,
                    colspan: 2,
                    rowspan: 1,
                    borderBottom: true,
                    borderRight: true,
                    value: ['bc_ls_01_install', 'bc_ls_01_usage']
                }, {
                    text: '预溶仪AL-PD-01',
                    align: 'center',
                    sortable: false,
                    colspan: 2,
                    rowspan: 1,
                    borderBottom: true,
                    borderRight: true,
                    value: ['al_pd_01_install', 'al_pd_01_usage']
                }, {
                    text: '预溶仪震荡版AL-PD-01A',
                    align: 'center',
                    sortable: false,
                    colspan: 2,
                    rowspan: 1,
                    borderBottom: true,
                    borderRight: true,
                    value: ['al_pd_01a_install', 'al_pd_01a_usage']
                }, {
                    text: '使用率',
                    align: 'center',
                    sortable: false,
                    colspan: 1,
                    rowspan: 2,
                    borderBottom: true,
                    value: 'usage_rate'
                }],
            headersLast: [
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' }
            ]
        };
        this.personTab = 0;
        // 个人
        this.personTableOptions = {
            visible: false,
            loading: false,
            desserts: []
        };
        const that = this;
    }
    getColor(item) {
        const rate = parseFloat(item.usage_rate);
        if (rate > 90)
            return 'green';
        else if (rate < 10)
            return 'pink darken-4';
        else if (rate < 60)
            return 'red';
        else if (rate < 70)
            return 'pink accent-3';
        else if (rate > 80 && rate < 90)
            return 'orange';
        else if (rate > 70 && rate < 80)
            return 'cyan';
        else
            return 'gray';
    }
    /**
     * 根据使用率返回对应的颜色
     * 作者: vacant<wq.chen@broadcare.com.cn>
     * 日期: 2025-09-15
     * 描述: 为设备使用率统计表格提供颜色区分显示
     * @param usageRateStr 使用率字符串，如 "85.5%"
     * @returns 颜色字符串
     */
    getUsageRateColor(usageRateStr) {
        if (!usageRateStr)
            return '#9e9e9e'; // 灰色 - 无数据
        const rate = parseFloat(usageRateStr.replace('%', ''));
        if (isNaN(rate))
            return '#9e9e9e'; // 灰色 - 无效数据
        // 根据使用率区间返回不同颜色，使用率越高颜色越明显
        if (rate >= 80)
            return '#f44336'; // 红色 - 高使用率（80%以上）
        else if (rate >= 60)
            return '#ff9800'; // 橙色 - 中等使用率（60%-80%）
        else if (rate >= 40)
            return '#fbc02d'; // 黄色 - 较低使用率（40%-60%）
        else if (rate >= 20)
            return '#8bc34a'; // 浅绿色 - 低使用率（20%-40%）
        else
            return '#4caf50'; // 绿色 - 很低使用率（20%以下）
    }
    get personTableHeaders() {
        const config = [{
                text: '人员',
                align: 'center',
                sortable: false,
                value: 'name',
            }, {
                text: '医院汇总',
                align: 'center',
                sortable: false,
                value: 'hospital_summary',
            }, {
                text: '设备总数',
                align: 'center',
                sortable: false,
                value: 'name',
            }, {
                text: '使用总数',
                align: 'center',
                sortable: false,
                value: 'usage_total',
            }, {
                text: '使用率',
                align: 'center',
                sortable: false,
                value: 'usage_rate',
            }];
        if (this.personTab == 0) {
            config.splice(1, 0, {
                text: '省份',
                align: 'center',
                sortable: false,
                value: 'duty_area',
            });
        }
        return config;
    }
    mounted() {
        const that = this;
        that.refreshAll();
    }
    refreshAll() {
        const that = this;
        that.getModeTableData();
        that.getAreaTableData();
        that.getPersonTableData();
    }
    /**
     * 获取各型号设备使用统计数据（支持动态设备类型）
     * author: vacant, wq.chen@broadcare.com.cn
     * date: 2025-09-15
     */
    async getModeTableData() {
        const that = this;
        that.modeTableOptions.loading = true;
        try {
            const result = await that.axios.get('/api/report/usage/mode');
            if (result && result.status === 200) {
                that.modeTableOptions.loading = false;
                // 更新动态表头
                if (result.data.headers && result.data.headers.length > 0) {
                    that.modeTableOptions.headers = result.data.headers;
                }
                // 处理表格数据
                that.modeTableOptions.desserts = result.data.result && result.data.result.map((item) => {
                    for (const key in item) {
                        try {
                            if (!isNaN(item[key])) {
                                if (item.name == '使用率')
                                    item[key] = `${Number(item[key]).toFixed(2)}%`;
                                else
                                    item[key] = Number(item[key]);
                            }
                        }
                        catch {
                        }
                    }
                    return item;
                });
                // 存储设备类型信息用于图表展示
                if (result.data.deviceTypes) {
                    that.deviceTypes = result.data.deviceTypes;
                }
            }
        }
        catch (e) {
            console.log('error of getModeTableData', e);
            that.modeTableOptions.loading = false;
            that.snackbar.error('获取各设备使用率统计失败，错误为:' + (typeof e === 'object' && JSON.stringify(e)) || e);
        }
        // 写入统计图（支持动态设备类型）
        const xData = [];
        const yData = [];
        // 组装所需数据
        if (that.modeTableOptions.desserts && that.modeTableOptions.desserts.length > 0) {
            const data = that.modeTableOptions.desserts.find((o) => o.name == '使用率');
            if (data && that.deviceTypes && that.deviceTypes.length > 0) {
                // 使用动态设备类型生成图表数据
                that.deviceTypes.forEach((deviceType) => {
                    const key = deviceType.toLowerCase().replace(/-/g, '_');
                    xData.push(deviceType);
                    const value = data[key] ? data[key].toString().replace('%', '') : '0';
                    yData.push(Number(value) || 0);
                });
            }
            else {
                // 兼容旧版本：从表头中获取数据（排除name和total列）
                that.modeTableOptions.headers.forEach((o) => {
                    if (!/name|total/.test(o.value)) {
                        xData.push(o.text);
                        const value = data[o.value] ? data[o.value].toString().replace('%', '') : '0';
                        yData.push(Number(value) || 0);
                    }
                });
            }
        }
        that.initChars(that.modeTableOptions.echartsOption, xData, yData);
    }
    async getAreaTableData() {
        const that = this;
        that.areaTableOptions.loading = true;
        try {
            const result = await that.axios.get('/api/report/usage/area');
            if (result && result.status === 200) {
                that.areaTableOptions.loading = false;
                that.areaTableOptions.desserts = result.data.result && result.data.result.map((item) => {
                    item['usage_rate'] = `${Number(item['usage_rate']).toFixed(2)}%`;
                    return item;
                });
            }
        }
        catch (e) {
            console.log('error of getcenter', e);
            that.areaTableOptions.loading = false;
            that.snackbar.error('获取各区域设备使用率统计失败，错误为:' + (typeof e === 'object' && JSON.stringify(e)) || e);
        }
        // 组装所需数据
        const xData = [];
        const yData = [];
        if (that.areaTableOptions.desserts && that.areaTableOptions.desserts.length > 0) {
            that.areaTableOptions.desserts.forEach((item) => {
                xData.push(item['duty_area']);
                yData.push(Number(item['usage_rate'].replaceAll('%', '')));
            });
        }
        const option = JSON.parse(JSON.stringify(that.modeTableOptions.echartsOption));
        option.domKey = 'charts_usage_area';
        option.series[0].itemStyle.normal.color = '#61A0A8';
        option.series[0].itemStyle.normal.label.textStyle.color = '#61A0A8';
        option.xAxis.axisLine.lineStyle.color = '#61A0A8';
        option.xAxis.axisPointer.label.formatter = (params) => `责任区域: ${params.value}`;
        that.initChars(option, xData, yData);
    }
    async getPersonTableData() {
        const that = this;
        that.personTableOptions.loading = true;
        try {
            const result = await that.axios.get('/api/report/usage/person', { params: { type: that.personTab || 0 } });
            if (result && result.status === 200) {
                that.personTableOptions.loading = false;
                that.personTableOptions.desserts = result.data.result && result.data.result.map((item) => {
                    item['usage_rate'] = `${Number(item['usage_rate']).toFixed(2)}%`;
                    return item;
                });
            }
        }
        catch (e) {
            console.log('error of getcenter', e);
            that.personTableOptions.loading = false;
            that.snackbar.error('获取各区域设备使用率统计失败，错误为:' + (typeof e === 'object' && JSON.stringify(e)) || e);
        }
        // 组装所需数据
        const xData = [];
        const yData = [];
        if (that.personTableOptions.desserts && that.personTableOptions.desserts.length > 0) {
            that.personTableOptions.desserts.forEach((item) => {
                xData.push((item['name'] || '') + (that.personTab == 0 ? `(${item['duty_area']})` : ''));
                yData.push(Number(item['usage_rate'].replaceAll('%', '')));
            });
        }
        const option = JSON.parse(JSON.stringify(that.modeTableOptions.echartsOption));
        option.domKey = 'charts_usage_person';
        const color = that.personTab == 0 ? '#61A0A8' : '#61A0A8';
        option.series[0].itemStyle.normal.color = color;
        option.series[0].itemStyle.normal.label.textStyle.color = color;
        option.xAxis.axisLine.lineStyle.color = color;
        that.initChars(option, xData, yData);
    }
    tabChange(event) {
        const that = this;
        that.getPersonTableData();
    }
    initChars(option, xData, yData) {
        const that = this;
        if (!option)
            return;
        // 检查必要的option属性
        if (!option.domKey) {
            console.warn('Chart option missing domKey, skipping chart initialization');
            return;
        }
        option.xAxis.data = xData;
        if (yData) {
            if (/object/i.test(typeof yData[0])) {
                for (const index in yData) {
                    option.series[index].data = yData[index];
                }
            }
            else {
                option.series[0].data = yData;
            }
        }
        // 使用$nextTick确保DOM完全渲染，并添加额外的延迟确保元素可用
        that.$nextTick(() => {
            setTimeout(() => {
                that.drawLine(option.domKey, option);
            }, 100); // 添加100ms延迟确保DOM元素完全可用
        });
    }
    drawLine(dom, option) {
        const that = this;
        const doc = document;
        const eleResize = EleResize;
        // 检查DOM元素是否存在
        const domElement = doc.getElementById(dom);
        if (!domElement) {
            console.warn(`DOM element with id '${dom}' not found, skipping chart initialization`);
            return;
        }
        const myChart = that.$echarts.init(domElement);
        const resizeDiv = doc.getElementById(dom);
        // 再次检查resize元素是否存在
        if (!resizeDiv) {
            console.warn(`Resize element with id '${dom}' not found, skipping resize listener`);
            return;
        }
        // 绘制图表
        myChart.setOption(option);
        eleResize.on(resizeDiv, () => myChart.resize());
    }
    // 获取边框style
    getBorderStyle(isTrue) {
        return isTrue ? 'thin solid rgba(0,0,0,.12)' : '';
    }
    /**
     * 导出使用率统计数据为Excel
     * 作者: vacant<wq.chen@broadcare.com.cn>
     * 日期: 2026-06-15
     * 描述: 将各型号设备使用统计、各区域设备使用统计、个人使用率统计、医院设备型号导出为Excel文件（4个Sheet）
     */
    async exportUsageData() {
        const that = this;
        that.exporting = true;
        try {
            const wb = XLSX.utils.book_new();
            // Sheet1: 各型号设备使用统计
            const modeHeaders = that.modeTableOptions.headers.map((h) => h.text);
            const modeRows = (that.modeTableOptions.desserts || []).map((item) => {
                return that.modeTableOptions.headers.map((h) => {
                    const val = item[h.value];
                    return val !== undefined && val !== null ? val : '';
                });
            });
            const modeSheet = XLSX.utils.aoa_to_sheet([modeHeaders, ...modeRows]);
            XLSX.utils.book_append_sheet(wb, modeSheet, '各型号设备使用统计');
            // Sheet2: 各区域设备使用统计
            const areaFirstHeaders = that.areaTableOptions.headersFirst;
            const areaLastHeaders = that.areaTableOptions.headersLast;
            // 构建两行表头
            const headerRow1 = [];
            const headerRow2 = [];
            for (const h of areaFirstHeaders) {
                const colspan = h.colspan || 1;
                headerRow1.push(h.text);
                for (let i = 1; i < colspan; i++)
                    headerRow1.push('');
                if (colspan > 1) {
                    for (const sub of areaLastHeaders.splice(0, colspan)) {
                        headerRow2.push(sub.text);
                    }
                }
                else {
                    headerRow2.push('');
                }
            }
            // 重新获取headersLast（上面splice会修改原数组，需重新赋值）
            that.areaTableOptions.headersLast = [
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' },
                { text: '装机量' }, { text: '使用量' }
            ];
            const areaDataRows = (that.areaTableOptions.desserts || []).map((item) => {
                const row = [];
                for (const h of areaFirstHeaders) {
                    const keys = h.value.toString().split(',');
                    for (const key of keys) {
                        row.push(item[key] !== undefined && item[key] !== null ? item[key] : '');
                    }
                }
                return row;
            });
            const areaSheet = XLSX.utils.aoa_to_sheet([headerRow1, headerRow2, ...areaDataRows]);
            XLSX.utils.book_append_sheet(wb, areaSheet, '各区域设备使用统计');
            // Sheet3: 个人使用率统计
            const personHeaders = that.personTableHeaders.map((h) => h.text);
            const personRows = (that.personTableOptions.desserts || []).map((item) => {
                return that.personTableHeaders.map((h) => {
                    const val = item[h.value];
                    return val !== undefined && val !== null ? val : '';
                });
            });
            const personSheet = XLSX.utils.aoa_to_sheet([personHeaders, ...personRows]);
            XLSX.utils.book_append_sheet(wb, personSheet, '个人使用率统计');
            // Sheet4: 医院设备型号明细
            // 使用 /api/hospital 接口，设备字段名为 mode/type/deviceNo
            try {
                const hospResult = await that.axios.get('/api/hospital', { params: { limit: 9999, short: true } });
                if (hospResult && hospResult.status === 200 && hospResult.data && hospResult.data.result) {
                    const hdHeaders = ['医院名称', '省份', '设备编号', '设备型号', '设备类型', '科室'];
                    const hdRows = [];
                    for (const hosp of hospResult.data.result) {
                        const devices = hosp.devices || [];
                        if (devices.length === 0) {
                            hdRows.push([hosp.name || '', hosp.area || hosp.province || '', '', '', '', '']);
                        }
                        else {
                            for (const dev of devices) {
                                hdRows.push([
                                    hosp.name || '',
                                    hosp.area || hosp.province || '',
                                    dev.deviceNo || dev.deviceId || '',
                                    dev.deviceMode || dev.mode || '',
                                    dev.deviceType || dev.type || '',
                                    dev.dept || '',
                                ]);
                            }
                        }
                    }
                    const hdSheet = XLSX.utils.aoa_to_sheet([hdHeaders, ...hdRows]);
                    // 添加自动筛选
                    hdSheet['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: hdRows.length, c: 5 } }) };
                    XLSX.utils.book_append_sheet(wb, hdSheet, '医院设备型号');
                }
            }
            catch (he) {
                console.warn('获取医院设备数据失败，跳过Sheet4:', he);
            }
            // 生成文件名
            const now = new Date();
            const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
            const timeStr = `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
            XLSX.writeFile(wb, `使用率统计_${dateStr}_${timeStr}.xlsx`);
            that.snackbar.success('导出成功');
        }
        catch (e) {
            console.error('导出使用率统计失败:', e);
            that.snackbar.error('导出失败，错误为:' + (typeof e === 'object' ? JSON.stringify(e) : e));
        }
        finally {
            that.exporting = false;
        }
    }
};
StatisticUsage = __decorate([
    Component({
        name: 'StatisticUsage',
        components: {
            BcSnackbar,
            BcDialog,
        },
    })
], StatisticUsage);
export default StatisticUsage;
;
